import { initializeGalleries } from "./modules/initSwiper";
import { createDynamicBlogNavigation } from "./modules/createDynamiBlogNavigation";
import { handleYoutubeIframeSizes, initBlogShortcodes } from "./modules/blog";

initBlogShortcodes();

document.addEventListener("DOMContentLoaded", () => {
  createDynamicBlogNavigation();
  initializeGalleries();
  handleYoutubeIframeSizes();
});
